import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      d="M10.6668 6.66663C11.035 6.66663 11.3334 6.36815 11.3334 5.99996C11.3334 5.63177 11.035 5.33329 10.6668 5.33329C10.2986 5.33329 10.0001 5.63177 10.0001 5.99996C10.0001 6.36815 10.2986 6.66663 10.6668 6.66663Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.32027 2.80616C8.41341 2.71663 8.53758 2.66663 8.66677 2.66663H13.5001C13.7762 2.66663 14.0001 2.89048 14.0001 3.16663V7.99996C14.0001 8.1329 13.9472 8.26037 13.853 8.35419L9.38864 12.8014C8.65615 13.531 7.46558 13.5111 6.758 12.7572L3.82881 9.63613C3.14175 8.90408 3.1713 7.75557 3.89511 7.05982L8.32027 2.80616ZM8.86811 3.66663L4.58811 7.78076C4.25911 8.09701 4.24567 8.61904 4.55797 8.95179L7.48713 12.0728C7.80876 12.4155 8.34992 12.4246 8.6829 12.0929L13.0001 7.79229V3.66663H8.86811Z"
      fill="currentColor"
    />
  </SvgIcon>
));
